import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {minWidthForDesktopLeftMenu} from "@/components/Menu/LeftMenu/LeftMenu";
import {RootState} from "@/store/Store";
import {CountWaitingVisitDate} from "@/api/Orders/CountWaitingVisitDate/CountWaitingVisitDate";

const UILeftMenuSlice = createSlice({
    name: "UILeftMenuSlice",
    initialState: {
        opened: window.innerWidth >= minWidthForDesktopLeftMenu,
        countWaitingVisitDate: 0,
    },
    reducers: {
        toggle: state => {
            state.opened = !state.opened;
        },
        show: state => {
            state.opened = true;
        },
        hide: state => {
            state.opened = false;
        },
        setCountWaitingVisitDate: (state, action: PayloadAction<number>) => {
            state.countWaitingVisitDate = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
          CountWaitingVisitDate.endpoints.getCountWaitingVisitDate.matchFulfilled,
          (state, action) => {
              state.countWaitingVisitDate = action.payload?.count;
          }
        )
    },
});

export const {toggle, show, hide, setCountWaitingVisitDate} = UILeftMenuSlice.actions;

//@ts-ignore
export const leftMenuOpenedSelector = state => state.uiLeftMenu.opened;

export const UILeftMenuReducer = UILeftMenuSlice.reducer;

export const countWaitingVisitDateSelector = (state: RootState) => state.uiLeftMenu.countWaitingVisitDate;
